import React from "react";
import DoctorVerifyOTP from "../DoctorSignup/DoctorVerifyOTP/DoctorVerifyOTP";
import useHospitalProviderRole from "./useHospitalProviderRole";

export default function HospitalVerifyOTP() {
  useHospitalProviderRole();
  return <DoctorVerifyOTP />;
}
